import API from './api';
import { Tag, TagCreate, TagUpdate } from '../types';

export const getTags = async (): Promise<Tag[]> => {
  const response = await API().get('/tags');
  return response.data;
};

export const createTag = async (tagData: TagCreate): Promise<Tag> => {
  const response = await API().post('/tags', tagData);
  return response.data;
};

export const updateTag = async (id: string, tagData: TagUpdate): Promise<Tag> => {
  const response = await API().put(`/tags/${id}`, tagData);
  return response.data;
};

export const deleteTag = async (id: string): Promise<void> => {
  await API().delete(`/tags/${id}`);
};
